import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@cnx/common";
import ApplicationFeatureService from "services/ApplicationFeatureService";
import { useAuthStore } from "stores/authStore";

export const useFeatureSupport = () => {
  const currentUserId = useAuthStore(state => state.currentUserId);

  const { data: features } = useQuery({
    queryKey: [QUERY_KEYS.APPLICATION_FEATURES],

    queryFn: async () => {
      const allFeatures = await ApplicationFeatureService.getAllFeatures();
      return allFeatures;
    },

    refetchInterval: 300000,
    enabled: !!currentUserId,
  });

  const isFeatureEnabled = (featureKey: string, value = 100): boolean => {
    if (!currentUserId) return false;

    const feature = features?.find(({ key }) => key === featureKey);
    return feature ? feature.implemented >= value : false;
  };

  return { isFeatureEnabled };
};
